import { Text } from '@linktr.ee/arbor/components/Text';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface MarketingConsentProps {
  show: boolean;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const checkboxName = 'linktree-marketing-consent';

const MarketingConsent: React.FC<MarketingConsentProps> = ({
  show,
  checked = false,
  onChange,
}) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <div className="pt-4">
      <div className="flex items-start gap-x-3">
        <input
          type="checkbox"
          id={checkboxName}
          name={checkboxName}
          checked={checked}
          onChange={() => onChange(!checked)}
          className="mt-1 h-4 w-4 rounded border-gray-300 text-accent focus:ring-accent"
        />
        <Text
          asChild
          variant="body-small-regular"
          className="text-black leading-5"
        >
          <label htmlFor={checkboxName}>
            {t('I agree to receive offers, news and updates from Linktree.')}
          </label>
        </Text>
      </div>
    </div>
  );
};

export default MarketingConsent;
